export const successSnackbarOptions = {
    autoHideDuration: 3000,
    variant: "success",
};
export const errorSnackbarOptions = {
    variant: "error",
};
